import type { SemanticColorToken } from '../themes/types';
import type { FontToken } from '../typography/types';

export const DEFAULT_FONT: FontToken = 'M_Regular';
export const DEFAULT_FONT_COLOR: SemanticColorToken = 'fg';
